import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getReportFileAPI(fileId) {
  const url = `${AWS_API_URL}/report/file/${fileId}`;
  const data = await getRequest(url, await authorize());
  return data.file;
}
